import type { ClickEventData } from 'providers/EventTrackingProvider';
import type { Lead } from 'providers/LeadProvider';

export function resolveEventData(
  eventData: ClickEventData,
  lead: Partial<Lead> | undefined,
) {
  return {
    category: eventData.category,
    label: eventData.label,
    contextData: {
      ...eventData.contextData,
      selfSignUpId: lead?.id ?? 'empty',
      leadId: lead?.id ?? 'empty',
      businessEmail: lead?.businessEmail ?? 'empty',
      formValues: lead,
      country: lead?.country ?? 'empty',
    },
  };
}
